import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import SignUpBanner from '../SignUpBanner'

const StaticSignUpBanner = (props) => {
  const signUpData = useStaticQuery(graphql`
    query {
      allContentfulSignUpBanner {
        edges {
          node {
            title
            description {
              childMarkdownRemark {
                html
              }
            }
            ctaLabel
            backgroundImage {
              file {
                url
              }
            }
          }
        }
      }
    }
  `)

  const signUpProps = signUpData.allContentfulSignUpBanner.edges[0].node
  return (<SignUpBanner {...signUpProps} />)
}

export default StaticSignUpBanner
